// extracted by mini-css-extract-plugin
module.exports = {"Header":"CorporateActionsDetails_Header__33MLv","Tabs":"CorporateActionsDetails_Tabs__2OFSW","TabBlocks":"CorporateActionsDetails_TabBlocks__19xR0"};